import { render, staticRenderFns } from "./AvatarEditor.vue?vue&type=template&id=0bd710a4&scoped=true"
import script from "./AvatarEditor.vue?vue&type=script&lang=ts"
export * from "./AvatarEditor.vue?vue&type=script&lang=ts"
import style0 from "./AvatarEditor.vue?vue&type=style&index=0&id=0bd710a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd710a4",
  null
  
)

export default component.exports